import { EXPRESS_API } from 'configs/api/expressApi';
import { useToastError } from 'lib/hooks';
import { useMutation } from 'react-query';
import { successToast } from 'lib/components/toasts/success';

export interface ITestSendQuickVideoPart {
  videoId?: number;
  quickVideoPartId: number;
}

interface ITestSendData {
  recipientName: string;
  inventoryItemId: number;
  quickVideoParts: ITestSendQuickVideoPart[];
  quickVideoId: number;
}

export const testSend = async (body: ITestSendData) => {
  return (
    await EXPRESS_API.post(`quick-videos/${body.quickVideoId}/test-send`, body)
  ).data;
};

export const useTestSendMutation = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const { showError } = useToastError();
  return useMutation(testSend, {
    onSuccess: () => {
      successToast({
        title:
          'Quick Video was successfully submitted and will be sent shortly.',
      });
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: err => {
      showError(err);
    },
  });
};
